/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import styles2 from "assets/jss/material-dashboard-react/views/dashboardStyle.js";
import Table from "components/Table/TableReport";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import Pagination from "react-responsive-pagination";
import "bootstrap/dist/css/bootstrap.min.css";
import { CardFooter } from "reactstrap";
import Cancel from "@material-ui/icons/Cancel";
import TSSelect from "components/Forms/TSSelect";
import Button from "components/CustomButtons/Button.js";
import { Modal, ModalBody } from "reactstrap";
import { red, green } from "@material-ui/core/colors";
import GetApp from "@material-ui/icons/GetApp";
import Visibility from "@material-ui/icons/Visibility";
import TableChart from "@material-ui/icons/TableChart";
import Assessment from "@material-ui/icons/Assessment";
import CheckCircle from "@material-ui/icons/CheckCircle";
import Warning from "@material-ui/icons/Warning";
import axios from "utils/httpClient";

const styles = {
    cardCategoryWhite: {
        color: "rgba(255,255,255,.85)",
        margin: "0",
        fontSize: "14px",
        marginTop: "4px",
        marginBottom: "0"
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "700",
        fontFamily: '"Sarabun", sans-serif',
        marginBottom: "3px",
        textDecoration: "none"
    }
};

const useStyles = makeStyles(styles);
const useStyles2 = makeStyles(styles2);

export default function Report() {
    const classes = useStyles();
    const classes2 = useStyles2();
    const [tableHead, setTableHead] = useState([]);
    const [pageSize] = useState(10);
    const [dataReport, setDataReport] = useState([]);
    const [modalError, setModalError] = useState(false);
    const [modalSuccess, setModalSuccess] = useState(false);
    const [successFileName, setSuccessFileName] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [isOpen, setIsOpen] = useState(false);
    const [name, setName] = useState("");
    const [reportId, setReportId] = useState(null);
    const [year, setYear] = useState("");
    const [oldOption1, setOldOption1] = useState("");
    const [oldOption2, setOldOption2] = useState("");
    const [oldOption3, setOldOption3] = useState("");
    const [disable1, setDisable1] = useState(true);
    const [disable2, setDisable2] = useState(true);
    const [disable3, setDisable3] = useState(true);
    const [l1Option, setL1Option] = useState([]);
    const [l2Option, setL2Option] = useState([]);
    const [l3Option, setL3Option] = useState([]);
    const [l4Option, setL4Option] = useState([]);
    const [option1, setOption1] = useState("");
    const [option2, setOption2] = useState("");
    const [option3, setOption3] = useState("");
    const [option4, setOption4] = useState("");
    const [isShow, setIsShow] = useState(false);
    const [optionsYear, setOptionsYear] = useState([]);

    // Export & Preview States
    const [isExporting, setIsExporting] = useState(false);
    const [isPreviewLoading, setIsPreviewLoading] = useState(false);
    const [previewData, setPreviewData] = useState([]);
    const [previewHeaders, setPreviewHeaders] = useState([]);
    const [reportStats, setReportStats] = useState(null);
    const [preparedExcel, setPreparedExcel] = useState(null);

    const windowWidth = useWindowWidth();

    function useWindowWidth() {
        const [wWidth, setWWidth] = useState(window.innerWidth - 400);

        useEffect(() => {
            const resizeHandler = () => {
                setWWidth(window.innerWidth - 400);
            };

            window.addEventListener("resize", resizeHandler);
            return () => {
                window.removeEventListener("resize", resizeHandler);
            };
        }, []);

        return wWidth;
    }

    // Clear preview when user switches filters or report
    useEffect(() => {
        setPreviewData([]);
        setPreviewHeaders([]);
        setReportStats(null);
        setPreparedExcel(null);
    }, [year, option1, option2, option3, option4, reportId]);

    // 1. Initial Load: Headers & Years
    useEffect(() => {
        setTableHead(["ชื่อรายงาน"]);

        axios("/api/v1/year/")
            .then(response => response.data)
            .then(
                result => {
                    setOptionsYear(result);
                    if (result && result.length > 0) {
                        setYear(result[0].value);
                    }
                },
                error => {
                    console.error(error);
                }
            );
    }, []);

    // 2. Load List of Available Reports (3 Reports)
    useEffect(() => {
        axios(
            "/api/v1/report/pagination?PageNumber=" +
            currentPage +
            "&PageSize=" +
            pageSize
        )
            .then(response => response.data)
            .then(
                result => {
                    var tableList = [];
                    if (result.data && result.data.length > 0) {
                        result.data.forEach(e => {
                            tableList.push([e.reportName, e.isShow, e.id]);
                        });
                    }

                    setDataReport(tableList);
                    var total = (result.total || 0) / pageSize;
                    if (!Number.isInteger(total)) {
                        setTotalPages((total | 0) + 1);
                    } else if (total === 0) {
                        setTotalPages(1);
                    } else {
                        setTotalPages(total);
                    }
                },
                error => {
                    console.error(error);
                }
            );
    }, [currentPage, pageSize]);

    const onOpen = () => {
        setIsOpen(true);
        setPreviewData([]);
        setPreviewHeaders([]);
        setReportStats(null);
        setPreparedExcel(null);
    };

    const onSetname = e => {
        setName(e);
    };

    const onSetReport = e => {
        setReportId(e);
    };

    const handleClose = () => {
        setIsOpen(false);
        setPreviewData([]);
        setPreviewHeaders([]);
        setReportStats(null);
        setPreparedExcel(null);
    };

    // Load Dropdown Options
    useEffect(() => {
        axios("/api/v1/group1")
            .then(
                result => {
                    if (result.data && result.data.data) {
                        setL1Option(result.data.data);
                    }
                },
                error => { console.error(error); }
            );
    }, []);

    useEffect(() => {
        if (option1 !== "") {
            axios("/api/v1/group2/" + option1)
                .then(
                    result => {
                        if (result.data && result.data.data) {
                            setL2Option(result.data.data);
                            setDisable1(false);
                            setOldOption1(option1);
                            if (option1 !== oldOption1) {
                                setOption2("");
                                setOption3("");
                                setOption4("");
                                setDisable2(true);
                                setDisable3(true);
                                setL3Option([]);
                                setL4Option([]);
                                setIsShow(false);
                            }
                        }
                    },
                    error => { console.error(error); }
                );
        }
    }, [option1, oldOption1]);

    useEffect(() => {
        if (option1 === 1 || option1 === 4) {
            if (option2 !== "") {
                axios("/api/v1/subGroup3/" + option2)
                    .then(response => response.data)
                    .then(
                        result => {
                            if (result && result.data) {
                                setL3Option(result.data);
                                setDisable2(false);
                                setOldOption2(option2);
                                if (option2 !== oldOption2) {
                                    setDisable3(true);
                                    setOption3("");
                                    setOption4("");
                                    setIsShow(false);
                                }
                            }
                        },
                        error => { console.error(error); }
                    );
            }
        } else {
            if (option2 !== "") {
                setOldOption2(option2);
                setIsShow(true);
            }
        }
    }, [option2, option1, oldOption2]);

    useEffect(() => {
        if (option1 === 4) {
            if (option3 !== "") {
                axios("/api/v1/subGroup4/" + option3)
                    .then(response => response.data)
                    .then(
                        result => {
                            if (result && result.data) {
                                setL4Option(result.data);
                                setDisable3(false);
                                setOldOption3(option3);
                                if (option3 !== oldOption3) {
                                    setOption4("");
                                    setIsShow(false);
                                }
                            }
                        },
                        error => { console.error(error); }
                    );
            }
        } else if (option3 !== "") {
            setIsShow(true);
        }
    }, [option3, option1, oldOption3]);

    useEffect(() => {
        if (option4 !== "") {
            setIsShow(true);
        }
    }, [option4]);

    const isCheck4 = () => {
        if (option1 !== oldOption1) return [{ value: "", label: "" }];
    };

    const isCheck5 = () => {
        if (option2 !== oldOption2) return [{ value: "", label: "" }];
    };

    const isCheck6 = () => {
        if (option3 !== oldOption3) return [{ value: "", label: "" }];
    };

    const isCheckYear = () => {
        if (year === "" && optionsYear.length > 0) {
            return [optionsYear[0]];
        } else {
            var val = optionsYear.filter(p => p.value === year);
            return val.length > 0 ? [val[0]] : [];
        }
    };

    // =========================================================================
    // 🌟 CORE EXCEL EXPORT ENGINE (SheetJS XLSX Integration)
    // =========================================================================
    const saveToExcelFile = (aoaData, sheetName, fileName, colWidths) => {
        const executeDownload = (XLSX) => {
            try {
                const ws = XLSX.utils.aoa_to_sheet(aoaData);
                if (colWidths) {
                    ws["!cols"] = colWidths;
                }
                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, sheetName.slice(0, 31));
                XLSX.writeFile(wb, fileName);
                setSuccessFileName(fileName);
                setModalSuccess(true);
                setIsExporting(false);
            } catch (err) {
                console.error("Excel generation error:", err);
                alert("เกิดข้อผิดพลาดในการสร้างไฟล์ Excel: " + err.message);
                setIsExporting(false);
            }
        };

        if (window.XLSX) {
            executeDownload(window.XLSX);
        } else {
            const script = document.createElement("script");
            script.src = "https://cdn.sheetjs.com/xlsx-0.20.1/package/dist/xlsx.full.min.js";
            script.onload = () => {
                if (window.XLSX) {
                    executeDownload(window.XLSX);
                }
            };
            script.onerror = () => {
                alert("ไม่สามารถโหลดไลบรารีสร้างไฟล์ Excel ได้ กรุณาตรวจสอบการเชื่อมต่ออินเทอร์เน็ต");
                setIsExporting(false);
            };
            document.head.appendChild(script);
        }
    };

    // Main Report Handler: autoDownload = false means "Preview First", true means "Download Immediately"
    const handleReport = (autoDownload = true) => {
        // If user wants to download and data is already loaded & prepared:
        if (autoDownload && preparedExcel) {
            setIsExporting(true);
            saveToExcelFile(
                preparedExcel.data,
                preparedExcel.sheetName,
                preparedExcel.fileName,
                preparedExcel.colWidths
            );
            return;
        }

        if (autoDownload) {
            setIsExporting(true);
        } else {
            setIsPreviewLoading(true);
        }

        const url = `/api/v1/report/export?group1=${option1}&group2=${option2}&group3=${option3}&group4=${option4}&year=${year}&id=${reportId}`;

        axios.get(url)
            .then(result => {
                const rawData = result.data ? result.data.data : [];
                if (!rawData || rawData.length === 0) {
                    setIsExporting(false);
                    setIsPreviewLoading(false);
                    setModalError(true);
                    return;
                }

                let formattedRows = [];
                let headers = [];
                let colWidths = null;
                let sheetName = "รายงาน";
                let fileName = `${name || "รายงาน"}_ปี_${year}.xlsx`;
                let stats = null;

                // Process each of the 3 reports cleanly:
                if (reportId === 1 || rawData[0].length >= 14) {
                    // =========================================================
                    // 📌 รายงานที่ 1: ผลงานตัวชี้วัดรายเดือน 12 เดือน (ต.ค. - ก.ย.)
                    // =========================================================
                    headers = [
                        "ลำดับ",
                        "ชื่อตัวชี้วัด",
                        "ค่าเป้าหมาย",
                        "ชื่อชุดข้อมูล",
                        "ต.ค.",
                        "พ.ย.",
                        "ธ.ค.",
                        "ม.ค.",
                        "ก.พ.",
                        "มี.ค.",
                        "เม.ย.",
                        "พ.ค.",
                        "มิ.ย.",
                        "ก.ค.",
                        "ส.ค.",
                        "ก.ย."
                    ];
                    formattedRows.push(headers);

                    for (let r = 1; r < rawData.length; r++) {
                        const row = rawData[r];
                        // Backend data mapping:
                        // row[0] = ลำดับ, row[1] = ค่าเป้าหมาย, row[2] = ชื่อตัวชี้วัด, row[3] = ชื่อชุดข้อมูล/ตัวตั้ง/ตัวหาร
                        // row[4]..row[15] = เดือน ต.ค. - ก.ย.
                        const cleanRow = [
                            row[0],
                            row[2],
                            row[1],
                            row[3],
                            row[4],
                            row[5],
                            row[6],
                            row[7],
                            row[8],
                            row[9],
                            row[10],
                            row[11],
                            row[12],
                            row[13],
                            row[14],
                            row[15]
                        ];
                        formattedRows.push(cleanRow);
                    }

                    colWidths = [
                        { wch: 8 },   // ลำดับ
                        { wch: 45 },  // ชื่อตัวชี้วัด
                        { wch: 22 },  // ค่าเป้าหมาย
                        { wch: 35 },  // ชื่อชุดข้อมูล
                        { wch: 11 },  // ต.ค.
                        { wch: 11 },  // พ.ย.
                        { wch: 11 },  // ธ.ค.
                        { wch: 11 },  // ม.ค.
                        { wch: 11 },  // ก.พ.
                        { wch: 11 },  // มี.ค.
                        { wch: 11 },  // เม.ย.
                        { wch: 11 },  // พ.ค.
                        { wch: 11 },  // มิ.ย.
                        { wch: 11 },  // ก.ค.
                        { wch: 11 },  // ส.ค.
                        { wch: 11 }   // ก.ย.
                    ];

                    const indicatorRows = formattedRows.slice(1);
                    stats = {
                        totalIndicators: indicatorRows.filter(r => r && r[0] !== "" && r[0] != null).length,
                        reportType: "MONTHLY_12"
                    };
                    sheetName = "ผลงานรายเดือน_12_เดือน";
                    fileName = `รายงานผลงานตัวชี้วัดประจำปี_ปี_${year}.xlsx`;

                } else if (reportId === 3) {
                    // =========================================================
                    // 📌 รายงานที่ 2: ตัวชี้วัดที่ยังไม่เป็นปัจจุบัน (กรอกข้อมูลไม่ครบ)
                    // =========================================================
                    headers = ["ลำดับ", "ชื่อตัวชี้วัด", "เดือน/ไตรมาสที่ยังไม่ได้กรอก", "ความถี่ในการกรอกข้อมูล"];
                    formattedRows.push(headers);

                    for (let r = 1; r < rawData.length; r++) {
                        formattedRows.push(rawData[r]);
                    }

                    const totalIncomplete = formattedRows.length - 1;
                    formattedRows.push([]);
                    formattedRows.push(["", "รวมตัวชี้วัดที่ต้องติดตามกรอกข้อมูลทั้งหมด:", `${totalIncomplete} รายการ`, ""]);

                    colWidths = [
                        { wch: 10 }, { wch: 50 }, { wch: 35 }, { wch: 25 }
                    ];

                    stats = {
                        totalIncomplete: totalIncomplete,
                        reportType: "INCOMPLETE_TRACKING"
                    };
                    sheetName = "ตัวชี้วัดที่ยังไม่เป็นปัจจุบัน";
                    fileName = `รายงานตัวชี้วัดที่ยังไม่เป็นปัจจุบัน_ปี_${year}.xlsx`;

                } else if (reportId === 6) {
                    // =========================================================
                    // 📌 รายงานที่ 3: ผลการประเมินตัวชี้วัด (ผ่าน / ไม่ผ่านเกณฑ์)
                    // =========================================================
                    headers = ["ลำดับ", "ชื่อตัวชี้วัด", "ชื่อชุดข้อมูล", "เดือนที่ไม่ผ่าน", "ผลการประเมิน"];
                    formattedRows.push(headers);

                    let passedCount = 0;
                    let failedCount = 0;

                    for (let r = 1; r < rawData.length; r++) {
                        const row = rawData[r];
                        formattedRows.push(row);
                        const status = row && row[4] != null ? String(row[4]).trim() : "";
                        if (status === "ผ่าน") passedCount++;
                        else failedCount++;
                    }

                    const totalEvaluated = passedCount + failedCount;
                    const passPercent = totalEvaluated > 0 ? ((passedCount / totalEvaluated) * 100).toFixed(1) : 0;

                    // Add Executive Summary block at bottom
                    formattedRows.push([]);
                    formattedRows.push(["", "", "", "สรุปตัวชี้วัดที่ผ่านเกณฑ์:", `${passedCount} รายการ (${passPercent}%)`]);
                    formattedRows.push(["", "", "", "สรุปตัวชี้วัดที่ไม่ผ่านเกณฑ์:", `${failedCount} รายการ`]);
                    formattedRows.push(["", "", "", "รวมที่ประเมินทั้งหมด:", `${totalEvaluated} รายการ`]);

                    colWidths = [
                        { wch: 10 }, { wch: 45 }, { wch: 30 }, { wch: 28 }, { wch: 16 }
                    ];

                    stats = {
                        total: totalEvaluated,
                        passed: passedCount,
                        failed: failedCount,
                        passPercent: passPercent,
                        reportType: "EVALUATION"
                    };
                    sheetName = "ผลการประเมินตัวชี้วัด";
                    fileName = `รายงานผลการประเมินตัวชี้วัด_ปี_${year}.xlsx`;

                } else {
                    // Generic fallback for any other report
                    headers = rawData[0] || [];
                    formattedRows = rawData;
                    fileName = `${name || "รายงาน"}_ปี_${year}.xlsx`;
                }

                // Set preview table & stats
                setPreviewHeaders(headers);
                if (reportId === 3) {
                    setPreviewData(formattedRows.slice(1, formattedRows.length - 2));
                } else if (reportId === 6) {
                    setPreviewData(formattedRows.slice(1, formattedRows.length - 4));
                } else {
                    setPreviewData(formattedRows.slice(1));
                }
                setReportStats(stats);

                const excelBundle = {
                    data: formattedRows,
                    sheetName: sheetName,
                    fileName: fileName,
                    colWidths: colWidths
                };
                setPreparedExcel(excelBundle);
                setIsPreviewLoading(false);

                if (autoDownload) {
                    saveToExcelFile(formattedRows, sheetName, fileName, colWidths);
                }
            })
            .catch(error => {
                console.error("API error:", error);
                setIsExporting(false);
                setIsPreviewLoading(false);
                alert("เกิดข้อผิดพลาดในการดึงข้อมูลรายงาน: " + error.message);
            });
    };

    return (
        <div>
            {/* 1. Report Selector Table */}
            <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                    <Card style={{ marginTop: "0" }}>
                        <CardHeader color="info">
                            <h4 className={classes.cardTitleWhite}>
                                📑 รายการรายงานตัวชี้วัด (KPI Reports)
                            </h4>
                            <p className={classes.cardCategoryWhite}>
                                เลือกรายงานที่ต้องการเพื่อกำหนดเงื่อนไข และแสดงตัวอย่างหรือดาวน์โหลดเป็นไฟล์ Excel (.xlsx)
                            </p>
                        </CardHeader>
                        <CardBody>
                            <Table
                                tableHeaderColor="info"
                                tableHead={tableHead}
                                tableData={dataReport}
                                name={onSetname}
                                isOpen={onOpen}
                                reportId={onSetReport}
                            />
                        </CardBody>
                        <CardFooter>
                            <Pagination
                                current={currentPage}
                                total={totalPages}
                                onPageChange={setCurrentPage}
                                maxWidth={windowWidth}
                            />
                        </CardFooter>
                    </Card>
                </GridItem>
            </GridContainer>

            {/* 2. Parameter Selection Form */}
            {isOpen && (
                <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                        <Card style={{ border: "2px solid #00acc1", borderRadius: "10px" }}>
                            <CardHeader color="info">
                                <GridContainer style={{ alignItems: "center" }}>
                                    <GridItem xs={10} sm={11} md={11}>
                                        <h4 className={classes.cardTitleWhite}>
                                            📊 {name}
                                        </h4>
                                        <p className={classes.cardCategoryWhite}>
                                            กรุณาเลือกปีงบประมาณและหน่วยงานที่ต้องการออกรายงาน
                                        </p>
                                    </GridItem>
                                    <GridItem xs={2} sm={1} md={1} style={{ textAlign: "right" }}>
                                        <Cancel
                                            style={{
                                                color: "#ffffff",
                                                fontSize: 32,
                                                cursor: "pointer",
                                                opacity: 0.9
                                            }}
                                            onClick={() => handleClose()}
                                        />
                                    </GridItem>
                                </GridContainer>
                            </CardHeader>
                            <CardBody>
                                <GridContainer>
                                    <GridItem xs={12} sm={6} md={3}>
                                        <label style={{ fontSize: "13px", fontWeight: "bold", color: "#333" }}>
                                            📅 ปีงบประมาณ:
                                        </label>
                                        <TSSelect
                                            options={optionsYear}
                                            zIndex={999}
                                            onChange={e => setYear(e)}
                                            default={optionsYear[0]}
                                            defaulfAdd={isCheckYear()}
                                        />
                                    </GridItem>

                                    <GridItem xs={12} sm={6} md={3}>
                                        <label style={{ fontSize: "13px", fontWeight: "bold", color: "#333" }}>
                                            1. กลุ่มงานหลัก:
                                        </label>
                                        <TSSelect
                                            zIndex={998}
                                            options={l1Option}
                                            onChange={e => setOption1(e)}
                                        />
                                    </GridItem>

                                    <GridItem xs={12} sm={6} md={3}>
                                        <label style={{ fontSize: "13px", fontWeight: "bold", color: "#333" }}>
                                            2. หน่วยงาน / งาน:
                                        </label>
                                        <TSSelect
                                            zIndex={997}
                                            options={l2Option}
                                            onChange={e => setOption2(e)}
                                            disabled={disable1}
                                            defaulfAdd={isCheck4()}
                                        />
                                    </GridItem>

                                    {(option1 === 1 || option1 === 4) && (
                                        <GridItem xs={12} sm={6} md={3}>
                                            <label style={{ fontSize: "13px", fontWeight: "bold", color: "#333" }}>
                                                3. งานย่อย:
                                            </label>
                                            <TSSelect
                                                zIndex={996}
                                                options={l3Option}
                                                onChange={e => setOption3(e)}
                                                disabled={disable2}
                                                defaulfAdd={isCheck5()}
                                            />
                                        </GridItem>
                                    )}

                                    {option1 === 4 && (
                                        <GridItem xs={12} sm={6} md={3} style={{ marginTop: "10px" }}>
                                            <label style={{ fontSize: "13px", fontWeight: "bold", color: "#333" }}>
                                                4. งานย่อยระดับ 4:
                                            </label>
                                            <TSSelect
                                                zIndex={995}
                                                options={l4Option}
                                                onChange={e => setOption4(e)}
                                                disabled={disable3}
                                                defaulfAdd={isCheck6()}
                                            />
                                        </GridItem>
                                    )}
                                </GridContainer>
                            </CardBody>

                            <CardFooter style={{ textAlign: "center", padding: "16px 20px" }}>
                                {isShow ? (
                                    <div style={{ display: "flex", justifyContent: "center", gap: "16px", flexWrap: "wrap" }}>
                                        {/* 1. Preview Button (No auto-download) */}
                                        <Button
                                            color="info"
                                            round
                                            size="lg"
                                            onClick={() => handleReport(false)}
                                            disabled={isPreviewLoading || isExporting}
                                            style={{
                                                fontWeight: "bold",
                                                fontSize: "15px",
                                                padding: "12px 28px",
                                                boxShadow: "0 4px 14px rgba(0,172,193,0.3)"
                                            }}
                                        >
                                            <Visibility style={{ marginRight: "8px", fontSize: "22px" }} />
                                            {isPreviewLoading
                                                ? "⏳ กำลังโหลดตัวอย่างข้อมูล..."
                                                : "👁️ แสดงตัวอย่างรายงาน (Preview ก่อนโหลด)"}
                                        </Button>

                                        {/* 2. Direct Download Button */}
                                        <Button
                                            color="success"
                                            round
                                            size="lg"
                                            onClick={() => handleReport(true)}
                                            disabled={isPreviewLoading || isExporting}
                                            style={{
                                                fontWeight: "bold",
                                                fontSize: "15px",
                                                padding: "12px 28px",
                                                boxShadow: "0 4px 14px rgba(46,125,50,0.3)"
                                            }}
                                        >
                                            <GetApp style={{ marginRight: "8px", fontSize: "22px" }} />
                                            {isExporting
                                                ? "⏳ กำลังสร้างไฟล์ Excel (.xlsx)..."
                                                : "📥 ดาวน์โหลด Excel (.xlsx)"}
                                        </Button>
                                    </div>
                                ) : (
                                    <div style={{ color: "#777", fontSize: "14px" }}>
                                        👆 กรุณาเลือกกลุ่มงานและหน่วยงานด้านบนให้ครบถ้วนเพื่อแสดงตัวอย่างหรือดาวน์โหลดรายงาน
                                    </div>
                                )}
                            </CardFooter>
                        </Card>
                    </GridItem>
                </GridContainer>
            )}

            {/* 3. Live Data Preview & Summary Analytics (Dashboard-style Preview) */}
            {previewData && previewData.length > 0 && (
                <GridContainer>
                    <GridItem xs={12}>
                        <Card style={{ borderRadius: "10px", border: "2px solid #81c784", marginTop: "10px" }}>
                            <CardHeader color="success" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "12px" }}>
                                <div>
                                    <h4 className={classes.cardTitleWhite}>
                                        <TableChart style={{ verticalAlign: "middle", marginRight: "8px" }} />
                                        ตัวอย่างข้อมูล: {name} ({previewData.length} รายการ)
                                    </h4>
                                    <p className={classes.cardCategoryWhite}>
                                        ตรวจสอบความถูกต้องของข้อมูลด้านล่าง แล้วกดดาวน์โหลดเป็นไฟล์ Excel (.xlsx) ได้ทันที
                                    </p>
                                </div>
                                <Button
                                    color="white"
                                    round
                                    size="md"
                                    onClick={() => handleReport(true)}
                                    disabled={isExporting}
                                    style={{
                                        fontWeight: "bold",
                                        color: "#1b5e20",
                                        fontSize: "14px",
                                        padding: "10px 22px",
                                        boxShadow: "0 4px 12px rgba(0,0,0,0.15)"
                                    }}
                                >
                                    <GetApp style={{ marginRight: "6px", fontSize: "20px" }} />
                                    {isExporting ? "กำลังสร้าง Excel..." : "📥 ดาวน์โหลดไฟล์ Excel (.xlsx)"}
                                </Button>
                            </CardHeader>
                            <CardBody>
                                {/* Summary Badge Box (ตามสไตล์ Dashboard) */}
                                {reportStats && (
                                    <div
                                        style={{
                                            backgroundColor: "#f0fdf4",
                                            padding: "14px 18px",
                                            borderRadius: "8px",
                                            border: "1px solid #bbf7d0",
                                            marginBottom: "16px",
                                            display: "flex",
                                            gap: "24px",
                                            alignItems: "center",
                                            flexWrap: "wrap"
                                        }}
                                    >
                                        {reportStats.reportType === "MONTHLY_12" && (
                                            <div>
                                                <span style={{ color: "#166534", fontWeight: "bold", fontSize: "14px" }}>
                                                    📊 รวมตัวชี้วัดทั้งหมดในรายงาน: {reportStats.totalIndicators} ตัวชี้วัด (ข้อมูลรายเดือน 12 เดือน ต.ค. - ก.ย.)
                                                </span>
                                            </div>
                                        )}

                                        {reportStats.reportType === "INCOMPLETE_TRACKING" && (
                                            <div>
                                                <span style={{ color: "#d97706", fontWeight: "bold", fontSize: "14px" }}>
                                                    ⚠️ รวมตัวชี้วัดที่ต้องติดตามกรอกข้อมูล: {reportStats.totalIncomplete} รายการ
                                                </span>
                                            </div>
                                        )}

                                        {reportStats.reportType === "EVALUATION" && (
                                            <>
                                                <div>
                                                    <span style={{ color: "#166534", fontWeight: "bold", fontSize: "14px" }}>
                                                        🟢 ผ่านเกณฑ์: {reportStats.passed} รายการ ({reportStats.passPercent}%)
                                                    </span>
                                                </div>
                                                <div>
                                                    <span style={{ color: "#dc2626", fontWeight: "bold", fontSize: "14px" }}>
                                                        🔴 ไม่ผ่านเกณฑ์: {reportStats.failed} รายการ
                                                    </span>
                                                </div>
                                                <div>
                                                    <span style={{ color: "#333", fontWeight: "bold", fontSize: "14px" }}>
                                                        ประเมินทั้งหมด: {reportStats.total} รายการ
                                                    </span>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                )}

                                {/* Scrollable Preview Table */}
                                <div style={{ overflowX: "auto", maxHeight: "480px", border: "1px solid #e0e0e0", borderRadius: "6px" }}>
                                    <table
                                        className="table table-bordered table-hover"
                                        style={{ fontSize: "13px", margin: 0 }}
                                    >
                                        <thead style={{ backgroundColor: "#e8f5e9", color: "#1b5e20", position: "sticky", top: 0, zIndex: 1 }}>
                                            <tr>
                                                {previewHeaders.map((head, hIdx) => (
                                                    <th
                                                        key={hIdx}
                                                        style={{
                                                            padding: "10px 8px",
                                                            textAlign: hIdx === 1 || hIdx === 3 ? "left" : "center",
                                                            whiteSpace: "nowrap"
                                                        }}
                                                    >
                                                        {head}
                                                    </th>
                                                ))}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {previewData.slice(0, 50).map((row, rIdx) => {
                                                const isSummaryRow = row[0] === "" && row[1] && String(row[1]).includes("รวม");
                                                return (
                                                    <tr
                                                        key={rIdx}
                                                        style={{
                                                            backgroundColor: isSummaryRow ? "#f1f8e9" : "#ffffff",
                                                            fontWeight: isSummaryRow ? "bold" : "normal"
                                                        }}
                                                    >
                                                        {row.map((cell, cIdx) => {
                                                            let cellColor = "#333";
                                                            let bgCell = "transparent";
                                                            if (cell === "ผ่าน") {
                                                                cellColor = "#2e7d32";
                                                                bgCell = "#e8f5e9";
                                                            } else if (cell === "ไม่ผ่าน") {
                                                                cellColor = "#c62828";
                                                                bgCell = "#ffebee";
                                                            }

                                                            return (
                                                                <td
                                                                    key={cIdx}
                                                                    style={{
                                                                        padding: "8px 10px",
                                                                        textAlign: cIdx === 1 || cIdx === 3 ? "left" : (cIdx >= 4 ? "right" : "center"),
                                                                        color: cellColor,
                                                                        backgroundColor: bgCell,
                                                                        whiteSpace: cIdx === 1 || cIdx === 3 ? "normal" : "nowrap"
                                                                    }}
                                                                >
                                                                    {cell !== null && cell !== undefined ? cell + "" : "-"}
                                                                </td>
                                                            );
                                                        })}
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>

                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "12px", flexWrap: "wrap", gap: "10px" }}>
                                    <div style={{ color: "#777", fontSize: "13px" }}>
                                        {previewData.length > 50 
                                            ? `* แสดงตัวอย่าง 50 รายการแรก (ในไฟล์ Excel จะมีครบทั้งหมด ${previewData.length} รายการ)`
                                            : `แสดงข้อมูลทั้งหมด ${previewData.length} รายการ`}
                                    </div>
                                    <Button
                                        color="success"
                                        round
                                        size="md"
                                        onClick={() => handleReport(true)}
                                        disabled={isExporting}
                                        style={{ fontWeight: "bold" }}
                                    >
                                        <GetApp style={{ marginRight: "6px" }} /> 📥 ดาวน์โหลดไฟล์ Excel (.xlsx)
                                    </Button>
                                </div>
                            </CardBody>
                        </Card>
                    </GridItem>
                </GridContainer>
            )}

            {/* Error Modal (No Data) */}
            <Modal toggle={() => setModalError(false)} isOpen={modalError} centered>
                <div className="modal-header justify-content-center" style={{ backgroundColor: "#ffebee" }}>
                    <Warning style={{ color: red[500], fontSize: "2.5em" }} />
                </div>
                <ModalBody style={{ textAlign: "center", padding: "20px" }}>
                    <h5 style={{ fontWeight: "bold", color: "#c62828", margin: "10px 0" }}>
                        ไม่พบข้อมูลรายงาน
                    </h5>
                    <p style={{ color: "#666", margin: 0 }}>
                        ไม่มีข้อมูลตัวชี้วัดในเงื่อนไขกลุ่มงานหรือปีงบประมาณที่เลือก กรุณาตรวจสอบเงื่อนไขอีกครั้ง
                    </p>
                </ModalBody>
                <div style={{ textAlign: "center", paddingBottom: "16px" }}>
                    <Button color="danger" type="button" onClick={() => setModalError(false)}>
                        ตกลง
                    </Button>
                </div>
            </Modal>

            {/* Success Modal (Excel File Downloaded) */}
            <Modal toggle={() => setModalSuccess(false)} isOpen={modalSuccess} centered>
                <div className="modal-header justify-content-center" style={{ backgroundColor: "#e8f5e9" }}>
                    <CheckCircle style={{ color: green[600], fontSize: "2.5em" }} />
                </div>
                <ModalBody style={{ textAlign: "center", padding: "20px" }}>
                    <h5 style={{ fontWeight: "bold", color: "#2e7d32", margin: "10px 0" }}>
                        ดาวน์โหลดไฟล์ Excel สำเร็จ!
                    </h5>
                    <p style={{ color: "#444", margin: "4px 0 10px" }}>
                        ไฟล์ <strong>{successFileName}</strong> ได้ถูกบันทึกลงในเครื่องของคุณเรียบร้อยแล้ว
                    </p>
                    <div style={{ fontSize: "12px", color: "#777" }}>
                        สามารถเปิดดูด้วยโปรแกรม Microsoft Excel, Google Sheets หรือ Numbers ได้ทันที
                    </div>
                </ModalBody>
                <div style={{ textAlign: "center", paddingBottom: "16px" }}>
                    <Button color="success" type="button" onClick={() => setModalSuccess(false)}>
                        ตกลง
                    </Button>
                </div>
            </Modal>
        </div>
    );
}